export function bindBackNumberTransitionEnd(
    dateContainer: HTMLElement,
    onTransitionEnd: (event: TransitionEvent) => void,
): void {
    dateContainer.addEventListener("transitionend", onTransitionEnd);
}

export function unbindBackNumberTransitionEnd(
    dateContainer: HTMLElement,
    onTransitionEnd: (event: TransitionEvent) => void,
): void {
    dateContainer.removeEventListener("transitionend", onTransitionEnd);
}

export function bindBackNumberToggleChange(toggle: HTMLInputElement, onChange: () => void): void {
    toggle.addEventListener("change", onChange);
}
